'use client';

import type { ReactNode } from 'react';
import { Popover } from '@mokoboko/components';

export const LockedPopoverContent = ({
  side,
  children,
}: {
  side: 'top' | 'bottom';
  children: ReactNode;
}) => (
  <Popover.Content
    side={side}
    className="max-w-64 rounded-xl border-none bg-ink px-2.5 py-2 text-center text-sm font-medium leading-5 text-white shadow-lg"
  >
    {children}
    <Popover.Arrow className="fill-ink" />
  </Popover.Content>
);
